import { ArrayUtil, DisplayType, DisplayValue, StringUtil } from "@mcleod/core";
import { Component, ComponentFactory } from "..";
import { Label } from "../components/label/Label";
import { LabelVariant } from "../components/label/LabelVariant";
import { Layout } from "../components/layout/Layout";
import { Panel } from "../components/panel/Panel";
import { PanelProps } from "../components/panel/PanelProps";
import { ScreenStack } from "../components/panel/ScreenStack";

export class DisplayedLayoutInfo extends Panel {
    private labelTitle: Label;
        
    constructor(sourceLayout?: Layout, props?: Partial<PanelProps>) {
        super({ id: "panelDisplayedLayoutInfo" });
        this.createTitleLabel();
        this.setProps({
            fillRow: true,
            margin: 0,
            marginBottom: 16,
            padding: 0,
            scrollY: true,
            ...props
        });
        const layoutInformationLabels = this.createLayoutInformationLabels(sourceLayout);
        if (!ArrayUtil.isEmptyArray(layoutInformationLabels)) {
            this.add(this.labelTitle, ...layoutInformationLabels);
        }
    }

    private createTitleLabel() {
        this.labelTitle = new Label({
            id: this.createInnerComponentId("labelTitle"),
            variant: LabelVariant.sectionHeading,
            text: "Layout Information"
        });
    }

    private createLayoutInformationLabels(sourceLayout: Layout): Component[] {
        const result: Component[] = [];
        const rootLayout = sourceLayout ?? ScreenStack.getCurrentLayout();
        if (rootLayout != null) {
            const layouts: Layout[] = [ rootLayout, ...rootLayout.findComponentsByType(Layout) ];
            layouts.forEach(layout => {
                const labelIdSuffix = layout.layoutName?.replace(/\//g, "-");
                const labelLayoutNameId = `labelLayoutName-${labelIdSuffix}`;
                const labelLayoutNameText = layout.layoutName;
                result.push(...ComponentFactory.createBulletedList([{
                    id: labelLayoutNameId,
                    text: labelLayoutNameText
                }]));

                if (!StringUtil.isEmptyString(layout.metadata?.id)) {
                    const labelCustomInfoId = `labelCustomInfo-${labelIdSuffix}`;
                    const updatedDateTime =
                        DisplayValue.getDateDisplayValue(layout.metadata.updateDateTime, DisplayType.DATETIME);
                    const labelCustomInfoText = `(Custom version '${layout.metadata.descr}', updated ${updatedDateTime})`;
                    ArrayUtil.getLastElement(result).rowBreak = false;
                    result.push(new Label({
                        id: labelCustomInfoId,
                        text: labelCustomInfoText
                    }));
                }
            });
        }
        return result;
    }
}
